<div [ngSwitch]="layout" *ngIf="colorPrimary && colorSecondary">
  <div *ngSwitchCase="1">
    <app-layout1 [colorPrimary]="colorPrimary" [colorSecondary]="colorSecondary"></app-layout1>
  </div>  
  <div *ngSwitchCase="2">
    <app-layout2 [colorPrimary]="colorPrimary" [colorSecondary]="colorSecondary"></app-layout2>
  </div>  
</div>